import { render, staticRenderFns } from "./OnboardingAutomod.vue?vue&type=template&id=490435c0&scoped=true"
import script from "./OnboardingAutomod.vue?vue&type=script&lang=js"
export * from "./OnboardingAutomod.vue?vue&type=script&lang=js"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./OnboardingAutomod.vue?vue&type=style&index=1&id=490435c0&prod&scoped=true&lang=css"
import style2 from "./OnboardingAutomod.vue?vue&type=style&index=2&id=490435c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490435c0",
  null
  
)

export default component.exports